import React, { useEffect, FC, useRef, useState } from 'react';

import SunEditor from 'suneditor-react';
import 'suneditor/dist/css/suneditor.min.css';
import { observer } from 'mobx-react-lite';
import { task_t } from '../../logic/types';
// import NextURLs from './NextURLs.jsx';
import { projectDetailsData, projectDetailsStore } from '../../stores/projectDetailsStore';
import M from 'materialize-css';
import { validateTaskWithErrorMSG } from '../../helpers/validators';
import { ModalComponent } from '@eyesee/eyesee-hub-npm-ui';
import DeleteModal from '../DeleteModal/DeleteModal';
import { projectsData, projectsStore } from '../../stores/projectsStore';
import './task.scss';
const introslideOptions: any = {
    buttonList: [
        [
            'undo',
            'redo',
            'font',
            'fontSize',
            'formatBlock',
            'blockquote',
            'bold',
            'underline',
            'italic',
            'strike',
            'subscript',
            'superscript',
            'fontColor',
            'hiliteColor',
            'textStyle',
            'outdent',
            'indent',
            'align',
            'horizontalRule',
            'list',
            'lineHeight',
            'link',
            'image',
            'fullScreen',
            'preview',
            'print',
        ],
    ],
    height: 450,
    font: ['Arial', 'Helvetica', 'Roboto', 'Calibri', 'Times New Roman'],
    imageFileInput: false,
};

const defaultErrors: any = {
    name: '',
    url: '',
    urlCheck: {},
};
const Task = observer(
    ({
        task,
        onDragStart,
        onDragOver,
        onDrop,
    }: {
        task: any;
        onDragStart: (e: React.DragEvent<HTMLDivElement>, task: task_t) => void;
        onDrop: (e: React.DragEvent<HTMLDivElement>, task: task_t) => void;
        onDragOver: (e: React.DragEvent<HTMLDivElement>) => void;
    }) => {
        const [errors, setErrors] = useState(defaultErrors);
        const editorRef = useRef(null);

        useEffect(() => {
            var elems = document.querySelectorAll('.collapsible');
            var instances: any = M.Collapsible.init(elems, {});
        }, []);

        let closeAllCollapsibles = () => {
            let collapsibles = document.getElementsByClassName('collapsible');
            for (let i = 0; i < collapsibles.length; i++) {
                let instance: any = M.Collapsible.getInstance(collapsibles[i]);
                instance.close();
            }
        };

        let callDragStart = (e: React.DragEvent<HTMLDivElement>, task: task_t) => {
            closeAllCollapsibles();
            onDragStart(e, task);
        };
        let handleDrop = (e: React.DragEvent<HTMLDivElement>) => {
            onDrop(e, task);
        };

        const onChange = (e: React.ChangeEvent<HTMLInputElement>, i?: number) => {
            e.stopPropagation();

            if (e.target.name === 'premium') {
                task.premium = e.target.checked;
                task.ssMode = false;
            } else if (e.target.name === 'ssMode') {
                task.ssMode = e.target.checked;
                task.premium = false;
            } else if (e.target.name === 'urlCheck' && i !== undefined) {
                task.urlCheck[i] = e.target.value;
            } else {
                task[e.target.name] = e.target.value;
            }

            const errors = validateTaskWithErrorMSG(task);

            if (Object.keys(errors).length > 0) {
                setErrors(errors);
            } else {
                setErrors(defaultErrors);
            }

            projectDetailsData.isDataSaved = false;
        };

        const onDeleteTask = (e: React.MouseEvent<HTMLElement>, taskId: string) => {
            e.stopPropagation();
            projectsData.isModalVisible = true;
            projectsData.modalData = taskId;
        };

        let deleteTask = (id: any) => {
            if (!projectDetailsData.project) return;
            let cell = projectDetailsStore.getCurrentCell();
            if (!cell) return;
            cell.tasks = cell.tasks.filter((task: task_t) => task.id !== id);
            projectDetailsData.project.cells = [...projectDetailsData.project.cells, cell];

            projectDetailsData.isDataSaved = false;
            projectsStore.hideModal();
        };

        let removeFromUrlCheckList = (url: string, index: Number) => {
            task.urlCheck = task.urlCheck.filter((currentUrl: string, i: number) => !(currentUrl === url && index === i));
        };

        let addToUrlCheckList = () => {
            task.urlCheck = [...task.urlCheck, 'example.com'];
        };

        let cell = projectDetailsStore.getCurrentCell();

        if (!task) return null;

        return (
            <ul className="task collapsible">
                <ModalComponent
                    hide={() => (projectsData.isModalVisible = false)}
                    component={
                        <DeleteModal
                            confirmFN={() => deleteTask(projectsData.modalData)}
                            hideModal={projectsStore.hideModal}
                            headerText={'Delete Task'}
                            contentText={'You are about to delete a task in cell. Are you sure? '}
                            confirmButtonText={'Delete'}
                        />
                    }
                    isVisible={projectsData.isModalVisible}
                />
                <li>
                    <div
                        id={String(task.id)}
                        className="collapsible-header"
                        draggable
                        onDragStart={(e) => callDragStart(e, task)}
                        onDragOver={onDragOver}
                        onDrop={(e) => handleDrop(e)}
                    >
                        <span className="task-title">
                            <i className="material-icons link">drag_indicator</i>
                            {task.name}
                        </span>
                        <div>
                            <i className="material-icons">keyboard_arrow_down</i>
                            <i
                                className="material-icons link indigo-text text-lighten-1"
                                onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
                                    closeAllCollapsibles();
                                    projectDetailsStore.duplicateTask(task.id);
                                }}
                                title="Duplicate"
                            >
                                file_copy
                            </i>
                            <i className="material-icons link red-text text-lighten-1" title="Delete" onClick={(e) => onDeleteTask(e, task.id)}>
                                delete
                            </i>
                        </div>
                    </div>

                    <div className="collapsible-body">
                        <span>
                            <div className="input-field">
                                <input type="text" name="name" value={task.name} onChange={onChange} />
                                <label className="active">Name</label>
                                <p className="error-msg"> {errors.name}</p>
                            </div>
                            <div className="input-field">
                                <input type="text" name="url" value={task.url} onChange={onChange} />
                                <label className="active">URL</label>
                                <p className="error-msg"> {errors.url}</p>
                            </div>
                            <div className="input-field__url-check">
                                <div className="url-check-header">
                                    <label className="active">URL Checks</label>
                                    <div className="button-wrapper">
                                        <span className="material-icons add" onClick={addToUrlCheckList}>
                                            add_circle_outline
                                        </span>
                                    </div>
                                </div>
                                <div className="url-check-input-wrapper">
                                    {task.urlCheck.map((url: string, i: number) => {
                                        return (
                                            <>
                                                <div>
                                                    <input type="text" name="urlCheck" value={task.urlCheck[i]} onChange={(e) => onChange(e, i)} />
                                                    <span className="material-icons remove" onClick={(e) => removeFromUrlCheckList(url, i)}>
                                                        remove_circle_outline
                                                    </span>
                                                </div>
                                                <p className="error-msg"> {errors?.urlCheck[i]}</p>
                                            </>
                                        );
                                    })}
                                </div>
                            </div>
                        </span>

                        <div className="checkbox-wrapper">
                            {cell?.version == 2 && (
                                <div className="input-field">
                                    <label className="active">
                                        <input
                                            type="checkbox"
                                            className={!!task.premium ? 'filled-in' : ''}
                                            name="premium"
                                            checked={!!task.premium}
                                            onChange={onChange}
                                        />
                                        <span>Premium A+</span>
                                    </label>
                                </div>
                            )}

                            {cell?.version == 2 && (
                                <div className="input-field">
                                    <label className="active">
                                        <input
                                            type="checkbox"
                                            className={!!task.ssMode ? 'filled-in' : ''}
                                            name="ssMode"
                                            checked={!!task.ssMode}
                                            onChange={onChange}
                                        />
                                        <span>SS MODE</span>
                                    </label>
                                </div>
                            )}
                        </div>

                        <div className="editor">
                            <label className="active">Description</label>

                            <SunEditor
                                ref={editorRef}
                                setContents={task.desc}
                                enableToolbar={true}
                                showToolbar={true}
                                setDefaultStyle="font-family: Arial; font-size: 18px;"
                                onChange={(content) => (task.desc = content)}
                                setOptions={introslideOptions}
                            />
                        </div>
                    </div>
                </li>
            </ul>
        );
    }
);
export default Task;
